import React, { useEffect } from 'react'
import './App.css'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { LoginPage } from './pages/LoginPage'
import { SignUpPage } from './pages/SignUpPage'
import { PasswordReset } from './pages/PasswordReset'
import { app } from './firebase'
import { HomePage } from './pages/HomePage'
import { CreateShopPage } from './pages/CreateShopPage'
import { ShopDetailPage } from './pages/ShopDetail'
import { EditShopPage } from './pages/EditShopPage'

const App = () => {
  useEffect(() => {
    const analytics = getAnalytics(app)
    logEvent(analytics, 'page_view', { page_path: '/' })
  }, [])

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signUp" element={<SignUpPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/shop/:shopId" element={<ShopDetailPage />} />
        <Route path="/PasswordReset" element={<PasswordReset />} />
        <Route path="/create-shop" element={<CreateShopPage />} />
        <Route path="/edit-shop/:shopId" element={<EditShopPage />} />
      </Routes>
    </Router>
  )
}

export default App
